// First Created - 16 May 2026
// Author - Atul Pandey

import { apiSlice } from '@/app/api/apiSlice'

export const googleCalendarAuthApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({

    getGoogleCalendarConnectionStatus: builder.query({
      query: () => ({
        url: '/googleCalendarAuth/status',
        validateStatus: (response, result) => {
          return response.status === 200 && !result.isError
        }
      }),
      providesTags: ['GoogleCalendarConnection'],
    }),

  }),
})

export const {
  useGetGoogleCalendarConnectionStatusQuery,
} = googleCalendarAuthApiSlice